import MainButton from "~/components/common/mainButton";
import { useLanguage } from "~/contexts/providers/language";
import englishTranslations from "~/localization/en";
import frenchTranslations from "~/localization/fr";
import { SubscriptionType } from "~/types/subscription/subscription.types";
import { subscriptionTypeToName } from "~/utils/constants/user";

import styles from "./index.module.scss";

type Props = {
  type: SubscriptionType;
  perks: { title: string; description?: string }[];
};

const SelectionMembership = ({ type, perks }: Props) => {
  const { language } = useLanguage();
  const membershipTexts =
    language === "En"
      ? englishTranslations.membershipPage
      : frenchTranslations.membershipPage;
  const membersNotice =
    language === "En"
      ? englishTranslations.membershipPage.membersNotice
      : frenchTranslations.membershipPage.membersNotice;

  return (
    <div className={styles.selectionMembership}>
      <h1>{subscriptionTypeToName[type]}</h1>
      <h5>
        {">"} {membersNotice}
      </h5>

      {perks.map(({ title, description }, i) => (
        <div className={styles.perk} key={`${type}-perk-${i}`}>
          <h4 dangerouslySetInnerHTML={{ __html: `* ${title}` }} />
          {description && (
            <p className={styles.perkDescription}>
              <em dangerouslySetInnerHTML={{ __html: `(${description})` }}></em>
            </p>
          )}
          {/* {benefits && (
            <ul>
              {benefits.map((benefit, i) => (
                <li key={i} dangerouslySetInnerHTML={{ __html: benefit }} />
              ))}
            </ul>
          )} */}
        </div>
      ))}
      {/* {type === SubscriptionType.NORMAL && (
        <div className={styles.perk}>
          <span onClick={handleOpenModal} style={{ cursor: "pointer" }}>
            <u>See our partnerships</u>
          </span>
        </div>
      )} */}
      <div className={styles.priceContainer}>
        <h4 className={styles.priceTag}>{membershipTexts.fullPrice}</h4>
        <h4 className={styles.priceTag}>{membershipTexts.reducedPrice}</h4>
      </div>
      <div className={styles.center}>
        <MainButton
          theme="white"
          href="/apply"
          className={styles.applicationButton}
        >
          {`→ ${membershipTexts.buttonText}`}
        </MainButton>
      </div>
    </div>
  );
};

export default SelectionMembership;
